import React from 'react';
import { connect } from 'react-redux';
import { MessageCard, Loader, ContainerControlSite, Content } from '@simplybenefits/sb-ui-library';
import Header from '../../components/Header.js';
import permissionLevel from '../../services/permissions.js';
import { toggleAvailability } from '../../actions/master.js';
import ChangeRequestsList from './components/ChangeRequestsList.js';

/**
 * @param master
 * @param dispatch
 * @param accessType
 * @returns {JSX.Element}
 * @constructor
 */
const Index = ({ master, dispatch, accessType }) => {

    /**
     * @private
     */
    const _toggleAvailability = () => {
        dispatch(toggleAvailability());
    };

    if (!permissionLevel('Administration', accessType).includes('read')) {
        window.location.href = '/403';
    }

    // TODO: Loading needs to be merged onto Dev first.
    if (!master.status) {
        return <Loader />;
    }

    return (
        <ContainerControlSite background={"true"}>
            <Header
                subHeader="Administration"
                selectedTitle="administration"
            />

            <Content>
                <MessageCard
                    isError={ master.status.toUpperCase() === 'UNAVAILABLE' }
                    title={`You are ${ master.status.toLowerCase() } for Administration`}
                    subtitle="Use the button below to toggle your administration availability. Change Requests will not be assigned to you while you are marked Unavailable."
                    btn
                    btnName={ master.status.toUpperCase() === 'AVAILABLE' ? 'I am Unavailable' : 'I am Available' }
                    btnOnClick={ _toggleAvailability }
                    btnCustomStyle={{ backgroundColor: master.status.toUpperCase() === 'UNAVAILABLE' && '#DA3328' }}
                />

                <ChangeRequestsList
                    master={ master }
                />
            </Content>

            <span id="administration" />
        </ContainerControlSite>
    );
};

/**
 *
 * @param {*} state
 */
const mapStateToProps = (state) => ({
    loading: state.adjudication.loading,
    master: state.master,
    accessType: state.master.access
});

export default connect(mapStateToProps)(Index);